import React from 'react';
import styled from 'styled-components';
import { XAlert, XAlertType } from '../../x/alert/XAlert';
import { XText } from '../../x/text/XText';
import { XTranslate } from '../../x/translate/XTranslate';
import { UiGrid, UiFlex, UiBox, UiButton } from '@open-stack/ui';
import { XInput } from '../../x/input/XInput';
import { UseFormImmerOutput } from '../../../hooks/form-immer';
import { XInputPhone } from '../../x/input/phone/XInputPhone';
import { XDrawerBottom } from '../../x/drawer-bottom/XDrawerBottom';
import { XDrawerBottomHeader } from '../../x/drawer-bottom/header/XDrawerBottomHeader';
import { termsAndConditions } from '../registration-overlay/terms';
import { useToggle } from '../../../hooks/toggle';

const Wrapper = styled.div`
    .underline {
        text-decoration: underline !important;
    }
`;

interface Props {
    form: UseFormImmerOutput<{
        name: string;
        areaCode: string;
        phone: string;
        isConfirmed: boolean;
        isAutoRegister: boolean;
        locationId: number;
        outletId: number;
        zoneId: number;
        zoneName: string;
    }>;
    outletGroupZones?: {
        id: number;
        name: string;
        zones: {
            id: number;
            name: string;
        }[];
    }[];
    zoneOptions?: { label: any; value: any }[];
}

export function CovidForm({ form, zoneOptions }: Props) {
    const [isTermsOpen, toggleIsTermsOpen] = useToggle();

    function getToggleButton(isActive) {
        return (
            <UiButton
                color={isActive ? 'success' : 'text-secondary'}
                variant="text"
                icon={isActive ? 'check_box' : 'check_box_outline_blank'}
            />
        );
    }

    return (
        <Wrapper>
            <UiGrid>
                <XAlert type={XAlertType.WARNING} padding={2}>
                    <XText>
                        <XTranslate id="covid_reg.description" />
                    </XText>
                </XAlert>

                <XInput {...form.getInputProps('name')} />

                <XInputPhone
                    areaCode={form.form.areaCode}
                    phone={form.form.phone}
                    onChange={({ areaCode, phone }) => {
                        form.updateField('areaCode')(areaCode);
                        form.updateField('phone')(phone);
                    }}
                />

                {zoneOptions && zoneOptions.length > 0 && (
                    <XInput {...form.getInputProps('zoneId')} options={zoneOptions} label="Choose zone" />
                )}

                <UiFlex
                    onClick={() => form.updateField('isAutoRegister')(!form.form.isAutoRegister)}
                    gap={2}
                    border
                    borderRadius
                    padding={2}>
                    {getToggleButton(form.form.isAutoRegister)}
                    <XText>Auto check-in into other venues</XText>
                </UiFlex>

                <UiFlex
                    onClick={() => form.updateField('isConfirmed')(!form.form.isConfirmed)}
                    gap={2}
                    border
                    borderRadius
                    padding={2}>
                    {getToggleButton(form.form.isConfirmed)}

                    <XText>
                        I confirm I don't have any symptoms of COVID-19 &{' '}
                        <span
                            className="underline"
                            onClick={(event) => {
                                event.stopPropagation();
                                toggleIsTermsOpen();
                            }}>
                            I agree to terms
                        </span>{' '}
                        for my contact information being stored for the next 14 days.
                    </XText>
                </UiFlex>
            </UiGrid>

            {isTermsOpen && (
                <XDrawerBottom onClose={toggleIsTermsOpen}>
                    <XDrawerBottomHeader title="Terms and conditions" onClose={toggleIsTermsOpen} />
                    <UiBox padding={2} dangerouslySetInnerHTML={{ __html: termsAndConditions }} />
                </XDrawerBottom>
            )}
        </Wrapper>
    );
}
